import {
  ActionChip,
  BREAKPOINTS,
  ComponentMStyling,
  ComponentSStyling,
  ComponentTextStyle,
  Size,
  StyledLink,
  SystemIcons
} from '@laerdal/life-react-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useMediaMatch } from 'rooks';
import styled from 'styled-components';
import { useSelector } from "react-redux";
import { Navigate, useNavigate } from 'react-router-dom';
import { selectUserPermissions, selectUserProfile } from '../store/slices/userSlice';

const WidgetContainer = styled.div`
  background: #e4f6f6;
  border-radius: 8px;
  width: 100%;
`;


const Title = styled.div`
  ${ComponentSStyling(ComponentTextStyle.Bold, null)}
  flex: 1;
  white-space: pre;

  ${BREAKPOINTS.MEDIUM} {
    ${ComponentMStyling(ComponentTextStyle.Bold, null)}
  }
`;

const WidgetContent = styled.div`
  margin: 24px;
  align-items: center; 
  display: flex;
  flex-direction: column;

  ${BREAKPOINTS.MEDIUM} {
    flex-wrap: wrap;
    flex-direction: row;
    align-items: start;
    gap: 8px;
  }
`;

const QuickLinks = () => {
  const { t } = useTranslation('landingPage');
  const isMediumScreen = useMediaMatch(BREAKPOINTS.MEDIUM.replace('@media ', ''));
  const navigate = useNavigate();
  const user = useSelector(selectUserProfile);
  const permissions = useSelector(selectUserPermissions);

  return (
    <WidgetContainer>
      <WidgetContent>
        { user?.currentOrganization &&
          <ActionChip
            icon={<SystemIcons.Manikin />}
            size={Size.Medium}
            text={t('My Products')}
            onClick={() => {
              window.location.href = `${process.env.REACT_APP_CONNECT_LINK}/products`
            }}></ActionChip>
        }

        <ActionChip
          icon={<SystemIcons.Mail />}
          size={Size.Medium}
          text={t('My Cases')}
          onClick={() => {
            window.location.href = `${process.env.REACT_APP_ACCOUNT_BASE}/cases`
          }}></ActionChip>

        { user?.currentOrganization &&
          <ActionChip
            icon={<SystemIcons.ListView />}
            size={Size.Medium}
            text={t('Orders & Invoices')}
            onClick={() => {
              window.location.href = `${process.env.REACT_APP_ACCOUNT_BASE}/ordersinvoices`
            }}></ActionChip>
        }


        { (permissions?.includes('organization.manageaccess') 
          || permissions?.includes('account.owner') ) &&
            <ActionChip
              icon={<SystemIcons.AddUser />}
              size={Size.Medium}
              text={t('Invite a Colleague')}
              onClick={() => {
                window.location.href = `${process.env.REACT_APP_ACCOUNT_BASE}/users`;
              }}></ActionChip>
          }

        <ActionChip
          icon={<SystemIcons.Support />}
          size={Size.Medium}
          text={t('Contact Support')}
          onClick={() => {
            navigate("/case/create");
          }}></ActionChip>
      </WidgetContent>
    </WidgetContainer>
  );
};

export default QuickLinks;
